import {
  ArrangementResource,
  Resource,
  StreamMetadata,
} from '@thiememeulenhoff/types';

const getStreamMetadata = (
  value: Resource | ArrangementResource,
): StreamMetadata | undefined => {
  if (value.streamMetadata) {
    return value.streamMetadata;
  }

  if (value.parent) {
    return getStreamMetadata(value.parent);
  }

  return undefined;
};

const getParent = (
  value: Resource | ArrangementResource,
  parent?: Resource | ArrangementResource,
  arrangementResource?: Resource | ArrangementResource,
): Resource | ArrangementResource | undefined => {
  const actualParent = value.parent ?? parent;
  if (!actualParent) {
    return undefined;
  }

  if (actualParent.digitalResourceType === 'arrangement') {
    return undefined;
  }

  const streamMetadata = getStreamMetadata(arrangementResource ?? actualParent);
  if (streamMetadata?.hasAutomaticStructureNumbering) {
    return undefined;
  }

  return actualParent;
};

export const getResourceNumber = (
  value: Resource | ArrangementResource,
  parent?: Resource | ArrangementResource,
  arrangementResource?: Resource | ArrangementResource,
  ignoreExistingNumber = false,
): string => {
  let resourceNumber = '';
  const valueNumber = value.navigationMetadata?.number;

  // Use existing number if already formatted
  if (valueNumber?.match(/^\d+\.\d+$/) && !ignoreExistingNumber) {
    return valueNumber;
  }

  const actualParent = getParent(value, parent, arrangementResource);

  if (valueNumber && actualParent?.navigationMetadata?.number) {
    resourceNumber = `${actualParent.navigationMetadata.number}.${valueNumber}`;
  } else if (valueNumber) {
    resourceNumber = valueNumber;
  }

  return resourceNumber.trim();
};
